import {
  afterEveryRender,
  Component,
  type ElementRef,
  input,
  signal,
  viewChild,
} from '@angular/core';

@Component({
  selector: 'tvd-control-error',
  template: `
    @if (!disabled() && (hint() || error())) {
      <div
        #container
        class="absolute text-xs mt-1 left-0 right-0 break-words"
        [class.text-primary]="!error()"
        [class.text-red-500]="error()"
        [innerHtml]="error() || hint()"
      ></div>
    }
  `,
  host: {
    class: 'block',
    '[style.margin-block-end.px]': 'height()',
  },
})
export class ControlErrorComponent {
  readonly error = input('');
  readonly hint = input('');
  readonly disabled = input(false);

  readonly container = viewChild<ElementRef>('container');
  readonly height = signal(0);

  constructor() {
    afterEveryRender(() => {
      const el = this.container()?.nativeElement;
      const h = el?.offsetHeight ?? 0;
      if (h !== this.height()) {
        this.height.set(h);
      }
    });
  }
}
